import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for errors involving React context.
export class ContextError extends ListManagerFrontendError {
  static errorName = 'ContextError';
}
